module.exports = __webpack_public_path__ + "static/media/banner-festival.866e7552.png";